module.exports = __webpack_public_path__ + "static/img/3.0487d066.png";